import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import moment from 'vue-moment'
import Notifications from 'vue-notification'
import * as Sentry from '@sentry/vue'
import {useAuth} from '@/plugins/auth'
import {useMicrosoftAuthService} from '@/config/useMicrosoftAuth'
import App from '@/App.vue'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

Vue.config.productionTip = false
Vue.use(Notifications)
Vue.use(moment)

navigator.serviceWorker.getRegistrations()
    .then(registrations => {
        registrations.forEach(registration => {
            registration.unregister()
        })
    })

if (import.meta.env.PROD) {
    Sentry.init({
        Vue,
        dsn: 'https://c6bc2de0fd2a42798169feab8a1cb8be@o616915.ingest.sentry.io/5750539',
        integrations: [
            Sentry.browserTracingIntegration({router}),
        ],
        tracesSampleRate: 1.0,
    })
}

const guard = useAuth()
const microsoftAuth = useMicrosoftAuthService()

const initializeApp = async () => {
    try {
        await microsoftAuth.initialize()
        const isOAuthRedirect = await microsoftAuth.handleRedirect()
        if (!isOAuthRedirect) await guard.auth()
    } catch (error) {
        console.error('Authentication error:', error)

        if (router.currentRoute.name !== 'login') {
            router.push({
                name: 'login',
                params: {microsoftError: 'Die Anmeldung mit Microsoft ist fehlgeschlagen'}
            })
        }
    }
}

// Initialize
initializeApp().finally(() => {
    new Vue({store, router, vuetify, render: h => h(App)}).$mount('#app')
})

guard.watchToken()
